import { useEffect, useState } from "react";
import { EMPTY_LIVE_SCALE, subscribeLiveScale } from "../lib/liveScale";

export function useLiveScale() {
  const [live, setLive] = useState(EMPTY_LIVE_SCALE);

  useEffect(() => subscribeLiveScale(setLive), []);

  return live;
}
